import { LOCALE } from "@/globalConsts/locale";
import { CURRENCY } from "@/globalConsts/currency";

export function mapLocaleToCurrency(locale: string): string {
  const localeCurrencyMap: { [key: string]: string } = {
    [LOCALE.DE]: CURRENCY.EUR,
    [LOCALE.NL]: CURRENCY.EUR,
    [LOCALE.EN]: CURRENCY.GBP,
    [LOCALE.US]: CURRENCY.USD,
  };

  return localeCurrencyMap[locale];
}
